import { atom } from 'jotai';
import { dataLockerMarkersToggleDisabledAtom } from '../dataLocker/vis';
import { playerMarkersToggleDisabledAtom } from '../player/vis';
import { sectionAtom } from '../section';
import { teamMarkersToggleDisabledAtom } from './teamVis';

const markersToggleDisableMapAtom = atom(() => ({
  player: playerMarkersToggleDisabledAtom,
  team: teamMarkersToggleDisabledAtom,
  dataLocker: dataLockerMarkersToggleDisabledAtom,
  game: atom(async () => false), // temp as game section doesn't use this atom yet
}));

export const markersToggleDisabledAtom = atom(get => {
  const section = get(sectionAtom);
  const markerTogglesMap = get(markersToggleDisableMapAtom);
  const isDisabled =
    /* gets around needing to add a item for each section since recruitment list won't have this atom */
    section && section in markerTogglesMap ? get(markerTogglesMap[section as keyof typeof markerTogglesMap]) : false;
  return isDisabled;
});
